// Import React
import React from "react";

// Import Spectacle Core tags
import { Heading, Slide, Image, Text } from "spectacle";

const image = require("./images/cat.gif");

export default () => {
  return (
    <Slide>
      <Heading size={1} textColor="tertiary">
        ¡Gracias!
      </Heading>
      <Image src={image} />
      <Text textSize={20} textColor="secondary">
        Presentación hecha con Spectacle
      </Text>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/04-conclusions/02-thank-you.js